// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#widgets-demo{display:flex;height:100%;width:100%}#widgets-demo .content{width:100%;height:100%;padding:1rem;overflow:auto}#widgets-demo .webex-form{margin:1rem}#widgets-demo .webex-section{background-color:white;margin:1rem 0;padding:.5rem 1rem;box-shadow:0 0.0625rem 0.125rem 0 #C6C7CA;border-radius:.25rem}#widgets-demo .flex-column{display:flex;flex-direction:column}#widgets-demo .fluid-height{flex:1}\n", ""]);
// Exports
module.exports = exports;
